import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'lime';
  className?: string;
  href?: string;
  onClick?: () => void;
}
const CTA_CLASSES = 'inline-flex min-h-[52px] select-none items-center justify-center gap-2.5 rounded-full bg-lime px-7 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_12px_28px_rgba(122,30,60,0.28)] transition-[background-color,transform] duration-150 ease-out hover:bg-lime-soft active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-base';
export function CtaButton({
  children,
  className = '',
  href,
  onClick
}: CtaButtonProps) {
  const classes = `${CTA_CLASSES} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-20" data-mp="19b1ndznzug4l">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} data-id="element-21" data-mp="198p9bxlcwpwt">
      {children}
    </button>;
}